import React, { useMemo } from "react";
import { Caption1 } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";

export const NotificationsCounter = ({ counter, className }) => {
  const notificationsCounter = useMemo(() => {
    return counter > 9 ? "9+" : counter;
  }, [counter]);

  return (
    <Caption1
      weight="bold"
      tabularNums
      color="only-white"
      className={classnames("notification-counter", className)}
    >
      {notificationsCounter}
    </Caption1>
  );
};

NotificationsCounter.propTypes = {
  counter: PropTypes.number.isRequired,
  className: PropTypes.string,
};

NotificationsCounter.defaultProps = {
  className: undefined,
};
